import React from "react";
import {Box, Container, Typography} from "@mui/material";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { ReactComponent as CautionIcon } from "../../assests/icons/caution_icon.svg";
import {ReactComponent as CloseIconRed} from '../../assests/icons/close_icon_red.svg';

const UnauthorisedPage = () => {
 
   
  return (
    <Box component={'div'} sx={{height:"75vh",overflow:'auto',padding: "4rem 0 ",marginRight:"0.2rem",marginTop:"0.2rem"}} >
			<Container sx={{width:'83.8%'}} disableGutters>
        <Dialog open={true}> 
         <Box sx={{display:'flex', flexDirection:'column',justifyContent:'center',alignItems:'center',padding:'2.5rem',width:'60rem',overflow:'hidden'}}>
        <Box sx={{display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%', paddingBottom:'0.2rem',borderBottom:'1px solid #c8c8c8'}}>
        <DialogTitle id="responsive-dialog-title" sx={{margin:'auto',padding:'0',fontSize:'2.5rem',color:'#cf2030'}}>
        Permission to access
        </DialogTitle>
        {/* <CloseIconRed /> */}
        </Box>
             <Box sx={{display:"flex", gap:"2.5rem", padding:"2.5rem 2rem",justifyContent:'center',alignItems:'flex-start'}}>
              <Box sx={{flex:"25%"}}>
<CautionIcon  sx={{width:"15.9rem"}}/>
              </Box>

        <Box sx={{flex:"75%",display:"flex", flexDirection:"column", alignItems:"flex-start",justifyContent:"space-between"}}>
        <DialogContent sx={{ padding:"0"}}>
          <DialogContentText >
          Oops! seems like you do not have the permission to access this website. Please contact the site administrator. 
          </DialogContentText>
        </DialogContent>
          <Typography sx={{marginTop:"2.5rem"}}>(Redirecting message / Button)</Typography>
     
        </Box>
      </Box>
      </Box>
      </Dialog>

      </Container>
      </Box>
  );
};

export default UnauthorisedPage;
